import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const EmptyMessagingPro = () => (
  <div className="sui-mt-6 sui-flex sui-flex-col sui-gap-8">
    <div className="sui-flex sui-flex-col sui-gap-3" data-testid="projects-empty-messaging">
      <Typography variant="body-base" weight="bold">Looks like you haven&apos;t started any projects yet.</Typography>
      <Typography>Start by saving your first project to keep everything organized and easily accessible.</Typography>
    </div>
  </div>
);

export { EmptyMessagingPro };

EmptyMessagingPro.displayName = 'ProjectSummaryEmptyMessagingPro';

EmptyMessagingPro.propTypes = {};

EmptyMessagingPro.defaultProps = {};
